// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "s/css/" + chunkId + "." + "1b02b968" + ".chunk.css";
};